<form [formGroup]="actionItemFormGroup" autocomplete="off">
  <app-mat-text-input formControlName="url" [label]="fieldLabels['url']" name="url" placeholder="Url Address">
  </app-mat-text-input>

  <app-mat-simple-select
    [selectItems]="httpMethods"
    formControlName="method"
    [label]="fieldLabels['method']"
    name="method"
    placeholder="Method"
  >
  </app-mat-simple-select>

  <app-mat-simple-select
    [selectItems]="authMethods"
    formControlName="authMethod"
    [label]="fieldLabels['authMethod']"
    name="authMethod"
    placeholder="Authentication"
    (valueChanged)="onAuthMethodChanged()"
  >
  </app-mat-simple-select>

  <ng-container *ngIf="isBasicAuth">
    <app-mat-text-input
      formControlName="authUsername"
      [label]="fieldLabels['authUsername']"
      name="authUsername"
      placeholder="Username"
      autocomplete="off username"
    >
    </app-mat-text-input>

    <app-mat-password-input
      formControlName="authPassword"
      [label]="fieldLabels['authPassword']"
      name="authPassword"
      placeholder="Password"
      autocomplete="off new-password"
    >
    </app-mat-password-input>
  </ng-container>
</form>
